import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

import { CMSFooter, CMSHeader } from '@/interfaces/cms';

type Context = {
  content?: {
    header?: CMSHeader;
    footer?: CMSFooter;
  };
} | null;

const CmsContext = createContext<Context | undefined>(undefined);

type Props = PropsWithChildren<{ content: NonNullable<Context>['content'] }>;

export const CMSProvider = ({ children, content }: Props) => {
  const contextValue = useMemo(() => ({ content }), [content]);
  return (
    <CmsContext.Provider value={contextValue}>{children}</CmsContext.Provider>
  );
};

export const MockCMSProvider = ({ children }: PropsWithChildren) => {
  return <CmsContext.Provider value={null}>{children}</CmsContext.Provider>;
};

export const useCMSContent = () => {
  const context = useContext(CmsContext);
  if (context === undefined)
    throw new Error(
      'useCMS must be used within CMSProvider or MockCMSProvider',
    );

  return context;
};
